import { BrnButton } from './lib/brn-button';

export * from './lib/brn-button';

export const BrnButtonImports = [BrnButton] as const;
